export default "__VITE_ASSET__Daa3Skt___"